import { onError } from '@apollo/client/link/error'
import { message } from 'antd'

import { alert } from '@/utils/alert'

export const authLink = onError(({ forward, operation, graphQLErrors, networkError }) => {
  if (networkError) {
    console.error(networkError, operation, graphQLErrors)

    // 展示 chat gpt error
    const result = networkError?.['result']
    if (result && result.statusCode === 400 && result.message?.includes('token')) {
      message.error(result.message, 5)
    }

    if (result?.error?.message) {
      message.error(result.error.message, 5)
    }
  }

  if (graphQLErrors) {
    const unauthorizedError = graphQLErrors?.find((e) => e.message === 'Unauthorized')
    if (unauthorizedError) {
      const path = unauthorizedError.path && unauthorizedError.path[0]
      const isInitialLoad = path === 'viewer' && operation.variables.isInitialLoad
      const otherPath = path !== 'viewer'
      if (!isInitialLoad || otherPath) {
        window.location.reload()
      }
    } else {
      graphQLErrors.forEach((e) => console.error(e))
      const error = graphQLErrors[0]
      alert({ operationName: operation.operationName, variables: operation.variables, error: error.message })
      if (error.extensions?.exception?.response?.statusCode !== 404) {
        message.error(error.message || error.extensions?.code, 10)
      }
    }
  }
  return forward(operation)
})
